import {Injectable, signal} from '@angular/core';

const TOAST_DURATION = 4000;

/**
 * Short-lived notification shown at the bottom of the screen (replaces MatSnackBar).
 */
@Injectable({
  providedIn: 'root'
})
export class ToastService {

  readonly message = signal<string | null>(null);
  private _timeout: ReturnType<typeof setTimeout>;

  show(message: string): void {
    clearTimeout(this._timeout);
    this.message.set(message);
    this._timeout = setTimeout(() => this.message.set(null), TOAST_DURATION);
  }
}
